module.exports = __webpack_public_path__ + "img/Z60Q_14.ae4d16dc.jpg";